export default "__VITE_ASSET__DC8$NHXN__"